// extracted by mini-css-extract-plugin
module.exports = {"starsWrapper":"TrustpilotStars_starsWrapper__t8Ewu","stars":"TrustpilotStars_stars___lRiB","star":"TrustpilotStars_star__hPAgf"};